import { render } from "./AdminLinkRouter.vue?vue&type=template&id=d5b58e1a&scoped=true"
import script from "./AdminLinkRouter.vue?vue&type=script&lang=js"
export * from "./AdminLinkRouter.vue?vue&type=script&lang=js"

import "./AdminLinkRouter.vue?vue&type=style&index=0&id=d5b58e1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5b58e1a"]])

export default __exports__